import SFImage from "./SFImage";
import anchorPoints from "./anchorPoints.js";

export default SFImage;
export { anchorPoints };



// WEBPACK FOOTER //
// ./js/components/SFImage/index.js